import { Component } from '@angular/core';
import { TableComponent } from '../../../../shared/components/table/table.component';
import { FormsModule } from '@angular/forms';
import { Fila } from '../../../../shared/models/fila';
import { DialogLcbEmbalagemComponent } from './dialog-lcb-embalagem/dialog-lcb-embalagem.component';
import { ToastState as ts } from '../../../../shared/enums/toast-state.enum';
import { FilaFilter } from '../../models/fila-filter';
import { MatDialog } from '@angular/material/dialog';
import { FilaService } from '../../../../shared/services/fila.service';
import { ToastService } from '../../../../shared/services/toast.service';
import { TableHeader } from '../../../../shared/models/table-header';
import { FaseId } from '../../../../shared/enums/fase.enum';
import { LocalId } from '../../../../shared/enums/local.enum';

@Component({
  selector: 'app-lcb-fila-embalagem',
  imports: [TableComponent, FormsModule],
  templateUrl: './lcb-fila-embalagem.component.html',
  styleUrl: './lcb-fila-embalagem.component.scss',
})
export class LcbFilaEmbalagemComponent {
  filaList: Fila[] = [];
  headers: TableHeader[] = [
    { value: 'recebimento.senha', label: 'Senha' },
    { value: 'dataEntrada', label: 'Data Entrada', pipe: 'datetime' },
    { value: 'dataChamada', label: 'Data Chamada', pipe: 'datetime' },
    { value: 'recebimento.milkrun', label: 'Milk Run' },
    { value: 'recebimento.critico', label: 'Crítico' },
    { value: 'recebimento.subidaDireta', label: 'Subida Direta - LOTS' },
  ];

  constructor(
    private toast: ToastService,
    private service: FilaService,
    private dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.loadFilaList();
  }

  loadFilaList() {
    const filter: FilaFilter = {
      faseId: FaseId.EMBALAGEM,
      localId: Number(LocalId.LCB),
    };

    this.service.getFiltered(filter).subscribe({
      next: (value) => {
        if (value && value.content) {
          this.filaList = [...value.content];
        }
      },
      error: (e) => {
        this.toast.showToast(
          ts.error,
          e.error[0] ?? 'Falha ao carregar filas.',
        );
      },
    });
  }

  edit(item: Fila) {
    const dialogRef = this.dialog.open(DialogLcbEmbalagemComponent, {
      data: item,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.toast.showToast(ts.success, 'Fila atualizada!');
        this.filaList = this.filaList.filter((item) => item.id !== result.id);
      }
    });
  }
}
